import React, { useState, useEffect, FC } from "react";
import { debounce } from "lodash";
import { update, Doc } from "typesaurus";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { ListNode } from "../../db";
import { extractImgSrc, addUpdatedAt } from "../../utils/misc";
import Editor from "../Editor/Editor";

const debounced = debounce((func: Function) => {
  func();
}, 1000);

interface IProps {
  node?: Doc<ListNode> 
}

const Sidebar: FC<IProps> = ({ node }) => {
  const [content, setContent] = useState<string>();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setContent(node ? node.data.note : undefined);
  }, [node]);

  if (!node) {
    return null;
  }

  const save = (value: string) => () => {
    node &&
      update(
        node.ref,
        addUpdatedAt({
          note: value,
          images: extractImgSrc(value)
        })
      );
  };

  const handleNoteChange = (value: string) => {
    setContent(value);
    debounced(save(value));
  };

  return (
    <div
      className={classNames("Tree__editor", {
        split: node
      })}
    >
      <h1 className="Tree__editor__header">
        <Link className="Header__link" to={`/node/${node.ref.id}/full`}>
          {node.data.content || "New Entry"}
        </Link>

        <Link className="Editor__header__close" onClick={save(content || '')} to="/">
          <i className="icon ion-ios-close"></i>
        </Link>
      </h1>
      <Editor
        nodeId={node.ref.id}
        key={node.ref.id}
        value={content}
        onChange={handleNoteChange}
      />
    </div>
  );
};

export default Sidebar;
